module.exports = __webpack_public_path__ + "static/media/trustwallet.c8077c80.svg";